import script from "./CaseEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseEdit.vue?vue&type=script&setup=true&lang=js"

import "./CaseEdit.vue?vue&type=style&index=0&id=6ff77b34&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff77b34"]])

export default __exports__